// Validated environment access for the web app. Fails fast in production builds.
export interface WebEnv {
  supabaseUrl: string;
  supabaseAnonKey: string;
  /**
   * Public URL operator-facing emails should embed (e.g. team invites).
   * Defaults to `window.location.origin` so a developer who self-invites
   * from `localhost` still gets a working link, but any production deploy
   * MUST set this to `https://app.peptideclients.com` so an invite sent
   * from a non-prod host doesn't ship a `localhost` URL to a real
   * recipient. Trailing slash trimmed at consumption time.
   */
  appUrl: string;
  /**
   * Public URL of the platform-admin console (e.g. `https://admin.peptideclients.com`).
   * Optional: when unset, UI affordances that link to the admin console are hidden.
   * This keeps the operator app from advertising a dead URL until the admin site is provisioned.
   */
  adminConsoleUrl: string | null;
}

function required(name: string, value: string | undefined): string {
  if (!value || value.length === 0) {
    throw new Error(
      `Missing required env var ${name}. Set it in apps/web/.env.local or in the Netlify site settings.`,
    );
  }
  return value;
}

function optional(value: string | undefined): string | null {
  if (!value || value.length === 0) return null;
  return value;
}

export const env: WebEnv = {
  supabaseUrl: required('VITE_SUPABASE_URL', import.meta.env.VITE_SUPABASE_URL as string),
  supabaseAnonKey: required(
    'VITE_SUPABASE_ANON_KEY',
    import.meta.env.VITE_SUPABASE_ANON_KEY as string,
  ),
  appUrl:
    optional(import.meta.env.VITE_APP_PUBLIC_URL as string | undefined) ??
    (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173'),
  adminConsoleUrl: optional(import.meta.env.VITE_ADMIN_CONSOLE_URL as string | undefined),
};
